import util from './util';

initEditor(document.getElementById('instructions-edit'));

function initEditor(editBtn) {
    if (!editBtn) return;

    const editor = {
        editBtn,
        cancelBtn: document.getElementById('instructions-cancel'),
        instructions: [],
        resetBtn: document.getElementById('instructions-reset'),
        saveBtn: document.getElementById('instructions-save'),
    };

    editor.editBtn.addEventListener('click', edit(editor));
    editor.saveBtn.addEventListener('click', save(editor));
    editor.cancelBtn.addEventListener('click', cancel(editor));
    editor.resetBtn.addEventListener('click', reset(editor));

    util.initialiseAddedNodes((addedNodes) => (
        addedNodes.forEach((addedNode) => {
            Array.from(addedNode.querySelectorAll('.instructions'))
                .filter((node) => (
                    !editor.instructions.find((instruction) => instruction.node === node)
                ))
                .forEach((node) => editor.instructions.push(initInstruction(node)));

            editor.editBtn.disabled = !editor.instructions.length;
        })
    ));
}

function edit(editor) {
    return () => {
        checkRemovedNodes(editor.instructions);
        hide(editor.editBtn);
        show(editor.saveBtn, editor.cancelBtn, editor.resetBtn);
        editor.instructions.forEach(({ editBtn }) => show(editBtn));
    };
}

function checkRemovedNodes(instructions) {
    instructions.filter(({ node }) => !document.body.contains(node))
        .forEach((instruction) => instructions.splice(instructions.indexOf(instruction), 1));
}

function hide(...elements) {
    elements.forEach((element) => util.showElement(element, false));
}

function show(...elements) {
    elements.forEach((element) => util.showElement(element));
}

function save({ instructions }) {
    return () => {
        checkRemovedNodes(instructions);

        ajax({
            url: 'admin/instructions/save',
            method: 'PUT',
            type: 'json',
            data: getData(instructions),
            documentType: 'json',
        }, (response, status) => {
            if (!response || status !== 200) {
                notification.notify('Error', 'An unexpected error occurred.', -1);
            } else if (response.status.value < 0) {
                notification.notify('Error', response.status.text, response.status.value);
            } else {
                update(instructions, response);
            }
        });
    };
}

function getData(instructions) {
    return {
        instructions: instructions.map(({ node, markdown }) => (
            {
                id: node.getAttribute('data-label-id'),
                markdown: markdown.value,
                type: node.getAttribute('data-label-type'),
                ...getPageData(node),
            }
        )),
    };
}

function getPageData(node) {
    if (!node) return;

    const mode = node.getAttribute('data-label-mode');
    const page = node.getAttribute('data-label-page');

    return mode && page ? { mode, page } : getPageData(node.parentElement);
}

function update(instructions, response) {
    instructions.forEach((instruction, index) => {
        hide(instruction.markdown);
        instruction.markdown.value = (response.instructions[index] || {}).markdown;
        instruction.value = instruction.markdown.value;
        hide(instruction.saveBtn, instruction.cancelBtn, instruction.resetBtn);

        instruction.markup.innerHTML = (response.instructions[index] || {}).markup;
        instruction.editBtn.textContent = instruction.value
            ? 'Edit instruction'
            : '+ Add instruction';
        show(instruction.markup, instruction.editBtn);
    });
}

function cancel(editor) {
    return () => {
        checkRemovedNodes(editor.instructions);
        editor.instructions.forEach((instruction) => {
            hide(instruction.markdown, instruction.editBtn);
            instruction.markdown.value = instruction.value;
            hide(instruction.saveBtn, instruction.cancelBtn, instruction.resetBtn);
            show(instruction.markup);
        });
        hide(editor.saveBtn, editor.cancelBtn, editor.resetBtn);
        show(editor.editBtn);
    };
}

function reset({ instructions }) {
    return async () => {
        const { isConfirmed } = await util.fireDialogBox({
            title: 'Reset page instructions',
            message: 'All instructions on the current page will be cleared.',
            confirmBtnLabel: 'Reset',
            cancelBtnLabel: 'Cancel',
            destructive: true,
        });
        if (!isConfirmed) return;

        checkRemovedNodes(instructions);

        ajax({
            url: 'admin/instructions/reset',
            method: 'PUT',
            type: 'json',
            data: getData(instructions),
            documentType: 'json',
        }, (response, status) => {
            if (!response || status !== 200) {
                notification.notify('Error', 'An unexpected error occurred.', -1);
            } else if (response.status.value < 0) {
                notification.notify('Error', response.status.text, response.status.value);
            } else {
                update(instructions, response);
            }
        });
    };
}

function initInstruction(node) {
    const instruction = {
        node,
        cancelBtn: node.querySelector('.instructions-cancel'),
        editBtn: node.querySelector('.instructions-edit'),
        markdown: node.querySelector('.instructions-markdown'),
        markup: node.querySelector('.instructions-markup'),
        resetBtn: node.querySelector('.instructions-reset'),
        saveBtn: node.querySelector('.instructions-save'),
    };

    instruction.editBtn.addEventListener('click', editInstruction(instruction));
    instruction.saveBtn.addEventListener('click', saveInstruction(instruction));
    instruction.cancelBtn.addEventListener('click', cancelInstruction(instruction));
    instruction.resetBtn.addEventListener('click', resetInstruction(instruction));

    return Object.assign(instruction, { value: instruction.markdown.value });
}

function editInstruction(instruction) {
    return () => {
        hide(instruction.markup, instruction.editBtn);
        show(instruction.markdown);
        window.autosize.update(instruction.markdown);
        show(instruction.saveBtn, instruction.cancelBtn, instruction.resetBtn);
    };
}

function saveInstruction(instruction) {
    return () => {
        ajax({
            url: 'admin/instructions/save',
            method: 'PUT',
            type: 'json',
            data: getData([instruction]),
            documentType: 'json',
        }, (response, status) => {
            if (!response || status !== 200) {
                notification.notify('Error', 'An unexpected error occurred.', -1);
            } else if (response.status.value < 0) {
                notification.notify('Error', response.status.text, response.status.value);
            } else {
                update([instruction], response);
            }
        });
    };
}

function cancelInstruction(instruction) {
    return () => {
        hide(instruction.markdown);
        instruction.markdown.value = instruction.value;
        hide(instruction.saveBtn, instruction.cancelBtn, instruction.resetBtn);
        show(instruction.markup, instruction.editBtn);
    };
}

function resetInstruction(instruction) {
    return () => {
        ajax({
            url: 'admin/instructions/reset',
            method: 'PUT',
            type: 'json',
            data: getData([instruction]),
            documentType: 'json',
        }, (response, status) => {
            if (!response || status !== 200) {
                notification.notify('Error', 'An unexpected error occurred.', -1);
            } else if (response.status.value < 0) {
                notification.notify('Error', response.status.text, response.status.value);
            } else {
                update([instruction], response);
            }
        });
    };
}
